module.exports = __webpack_public_path__ + "static/media/truck.1efc32aa.svg";